export const EXCEL_LINE_KEY_REGEX = /^[A-Z]+$/;

export function isExcelLineKey(value: unknown): value is string {
  return typeof value === "string" && EXCEL_LINE_KEY_REGEX.test(value);
}

export function excelLabelForIndex(index: number): string {
  if (!Number.isFinite(index) || index < 0) return "";

  let label = "";
  let current = Math.floor(index);

  while (current >= 0) {
    label = String.fromCharCode(65 + (current % 26)) + label;
    current = Math.floor(current / 26) - 1;
  }

  return label;
}

export function excelLabelToIndex(label: string): number {
  if (!isExcelLineKey(label)) return -1;

  let result = 0;
  for (let i = 0; i < label.length; i++) {
    result = result * 26 + (label.charCodeAt(i) - 64);
  }

  return result - 1;
}

export function sortExcelLineKeys(keys: string[]): string[] {
  return [...keys].sort((a, b) => excelLabelToIndex(a) - excelLabelToIndex(b));
}
